import styled from "styled-components";

export const ModalContainer = styled.div`
  background-color: white;
  width: 30vw;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: column;
  text-align: left;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
  gap: 8px;
`;

